// src/components/Footer.tsx
import { Link } from 'react-router-dom';


const footerNavItems = [
  { to: '/', label: 'HEM' },
  { to: '/kurser', label: 'KURSER' },
  { to: '/forestallningar', label: 'FÖRESTÄLLNINGAR' },
  { to: '/boka-oss', label: 'BOKA OSS' },
  { to: '/lokal', label: 'LOKAL' },
  { to: '/om-oss', label: 'OM OSS' },
  { to: '/kursledare', label: 'KURSLEDARE' },
  { to: '/presentkort', label: 'PRESENTKORT' },
  { to: '/house-team', label: 'House team' },
  { to: '/om-impro', label: 'OM IMPROV COMEDY' },
  { to: '/var-filosofi', label: 'VÅR FILOSOFI' },
  { to: '/studentmanual', label: 'STUDENTMANUAL' },
  { to: '/vanliga-fragor', label: 'VANLIGA FRÅGOR' },
  { to: '/integritet', label: 'INTEGRITET & COOKIES' },
];

export default function Footer() {
  return (
    <footer className="bg-footer-black py-8 md:py-12" style={{ color: 'rgb(var(--white))' }}>
      <div className="container mx-auto px-6 lg:px-8">
        <div className="flex flex-col md:flex-row md:justify-between md:items-start space-y-8 md:space-y-0">
          
          {/* #2 Länkdelen - först på mobil, sist på desktop */}
      <nav className="flex flex-col space-y-2 order-1 md:order-2 md:text-right">
        {footerNavItems.map(({ to, label }) => {
          const isSpecial = to === '/integritet' || to === '/om-impro' || to === '/var-filosofi' || to === '/vanliga-fragor' || to === '/studentmanual' || to === '/kursledare' || to === '/house-team' || to === '/presentkort';
          const display = to === '/integritet' ? 'Integritet & cookies' : to === '/om-impro' ? 'Om improv comedy' : to === '/var-filosofi' ? 'Vår filosofi' : to === '/vanliga-fragor' ? 'Vanliga frågor' : to === '/studentmanual' ? 'Studentmanual' : to === '/kursledare' ? 'Kursledare' : to === '/house-team' ? 'House team' : to === '/presentkort' ? 'Presentkort' : label;
          return (
            <Link
              key={to + label}
              to={to}
              className={`font-satoshi text-sm tracking-wider hover:opacity-80 transition-colors ${isSpecial ? 'normal-case no-underline' : 'uppercase underline'}`}
              style={{ color: 'rgb(var(--white))' }}
            >
              {display}
            </Link>
          );
        })}
      </nav>

          {/* #1 Logotyp-delen - andra på mobil, först på desktop */}
          <div className="md:max-w-md order-2 md:order-1">
            <h2 className="font-tanker text-[32px] leading-tight mb-4" style={{ color: 'rgb(var(--white))' }}>
              LILLA IMPROTEATERN
            </h2>
            
            <p className="text-sm mb-6" style={{ color: 'rgb(var(--white))' }}>
              Org. nr: 559537-8786<br />
              <a href="mailto:kontakt@improteatern.se" className="underline focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-white" style={{ color: 'rgb(var(--white))' }}>
                kontakt@improteatern.se
              </a><br />
              Stockholm
            </p>

            <div className="text-sm mb-6 leading-relaxed" style={{ color: 'rgb(var(--white))' }}>
              <div className="font-bold mb-2">Adress:</div>
              <div className="mb-3">
                Föreställningar<br />
                Gamestreet 1, Magnus Ladulåsgatan 1, 118 65 Stockholm
              </div>
              <div>
                Kurser<br />
                ABF-huset, Sveavägen 41, 111 34 Stockholm
              </div>
            </div>

            
            <p className="font-tanker text-[18px] leading-relaxed" style={{ color: 'rgb(var(--white))' }}>
              Lilla improteatern står på helt egna ben, utan kulturstöd. Genom att delta i våra 
              kurser, se våra föreställningar eller boka oss bidrar du till ett levande kulturliv.
            </p>
          </div>

        </div>
      </div>
    </footer>
  );
}